export const mapStyles = [
  {
    elementType: 'all',
    featureType: 'administrative',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#f4f0f0',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'landscape',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#f2f2f2',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'landscape',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'landscape.man_made',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'landscape.natural',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'landscape.natural.landcover',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'landscape.natural.terrain',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'road',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'labels',
    featureType: 'road',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    featureType: 'road',
    stylers: [
      {
        hue: '#00ffa0',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'road.highway',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'labels',
    featureType: 'road.highway',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels',
    featureType: 'road.highway.controlled_access',
    stylers: [
      {
        visibility: 'on',
      },
      {
        hue: '#7200ff',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'road.arterial',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels',
    featureType: 'road.arterial',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'road.local',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'transit.line',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'transit.station',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'all',
    featureType: 'water',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
];
